<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="far fa-address-card mr-4 text-blue-500 ml-4"></i>
            </div>
        </template>
        <div>
            <ui-textarea autoresize name="description" placeholder="What needs to be done?"
                         v-model="description"></ui-textarea>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new danger class="w-full whitespace-nowrap mr-1.5 py-2" :loading="form.busy"
                               @click="description = ''; form.submit()"
                ><i class="fas fa-trash mr-2"></i>Delete</ui-button-new>
                <ui-button-new primary class="w-full whitespace-nowrap ml-1.5" :loading="form.busy"
                               @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>

import UiModal from "../../../../ui/UiModal.vue";
import UiButtonNew from "../../../../ui/UiButtonNew.vue";
import UiInput from "../../../../ui/UiInput.vue";

export default {
    components: {UiInput, UiButtonNew, UiModal},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Add Date'
        },
        button: {
            type: String,
            default: 'Save'
        },
        desc: {
            type: String,
            default: ''
        },
        name: '',
        contacts: {}
    },
    data() {
        return {
            description: this.desc,
            form: new Form({}, async (form) => {
                await this.handle(form, this);
                this.close();
            }),
        }
    },
    methods: {}
}
</script>
